export default __webpack_public_path__ + "Assets/PREMIUM/nordwest/Teilnahme-Bedingungen_zum_AOK-Praemienprogramm.pdf";